import { render } from "./wButtonRemove.vue?vue&type=template&id=1bffc7ac&ts=true"
import script from "./wButtonRemove.vue?vue&type=script&lang=ts"
export * from "./wButtonRemove.vue?vue&type=script&lang=ts"

import exportComponent from "E:\\Work\\Sales point\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__